import { transformUpgradeType, UpgradeType } from '@freelancer/ui/upgrade-tag';
import { isDefined } from '@freelancer/utils';
import { ContestApi } from 'api-typings/contests/contests';
import { ContestUpgrade } from '../contests/contests.model';
import {
  transformContest,
  transformContestUpgrades,
} from '../contests/contests.transformers';
import { SearchActiveContest } from './search-active-contests.model';

export function transformSearchActiveContest(
  contest: ContestApi,
): SearchActiveContest {
  if (!contest.jobs || !contest.type || !contest.upgrades) {
    throw new ReferenceError(`Missing a required contest entry field.`);
  }
  return {
    ...transformContest(contest),
    entryCount: contest.entry_count ?? 0,
    prize: contest.prize ?? 0,
    skillIds: contest.jobs.map(job => job.id),
    timeSubmitted: contest.time_submitted ? contest.time_submitted * 1000 : 0,
    upgradeNames: transformUpgradeNames(
      transformContestUpgrades(contest.type, contest.upgrades),
    ),
  };
}

export function transformUpgradeNames(
  upgrades: ContestUpgrade,
): readonly UpgradeType[] {
  return Object.entries(upgrades)
    .filter(([_, value]) => value)
    .map(([upgrade, _]) => transformUpgradeType(upgrade))
    .filter(isDefined);
}
